import { useStateMachine } from "little-state-machine";
import { UAParser } from 'ua-parser-js';
import {getSubtotal} from "./useCalculators";
import { signupApi } from "../Api";
import { dataLayerPush } from "./analytics";
import { getCookie } from "./cookies";
import isDev from "./isDev";

function _sendState({session}) {
  const {availableServices, currentAddress, isLoading, ...restProps} = session;

  // address is the bare minimum for sending the state
  if(!currentAddress) {
    return Promise.resolve();
  }

  const { browser, os } = UAParser();
  const browserInfo = browser.name + " " + browser.version + " " + os.name;

  // Note: This is always off by 1
  // i.e. if we're CURRENTLY on the choose-wifi screen, perform the previous page's action (so we don't have to modify submissionUpdate.php)
  let page = null;
  let pageHeaderText = null;

  /*
  0 Let's Get Started
  (how did you hear about us)


21 Great news! We are coming to your area!
25 Great news! i3 Fiber is available at your address!

3 Choose Internet Speed

4 How Many Smart WiFi Devices Do You Need?

5 Would you like to add i3 Phone Connection?

6 Order Summary

7 Almost there!

8 Payment Options

9 Way to Go! (unused)
  */


  switch(session.page) {
    /*
    case 'address-available':
    case 'presale':
      page = '1';
      break;
    */

    case 'presale':
    case 'address-available':
      page = '1';
      pageHeaderText = '';
      break;
    case 'choose-internet':
      page = '2';
      pageHeaderText = session.isPreorder ? 'Great news! We are coming to your area!' : 'Great news! i3 Fiber is available at your address!';// 'Choose Internet Speed';
      break;

    case 'choose-wifi':
      page = '3'; // save internet page
      pageHeaderText = 'Choose Internet Speed';//'How Many Smart WiFi Devices Do You Need?';
      break;
    case 'order-summary':
      page = '5'; // save phone page
      pageHeaderText = 'Would you like to add i3 Phone Connection?';//'Order Summary';
      break;
    case 'order-customer':      
      page = '6';
      pageHeaderText = 'Almost there!';
      break;
    case 'presale-notify':
    case 'order-payment':
      page = '7';
      pageHeaderText = 'Order Summary';
      break;
    case 'presale-notify-complete':
    case 'order-complete':
      page = '8';
      pageHeaderText = 'Way to Go!';
      break;
  }

  let obj = {
    ...restProps,
    browser: browserInfo,
    buyflowScreen: session.page,
    page,
    total: getSubtotal(session).toString(),

    /*
    signupstep: signupstep,
    page: page,
    addressResult: addRes,
    ip: ip,
    browser: browser,
    mainline: step,

    tv: tv,
    tvAmount: tva,
    tvid: tvid,
    box: box,
    boxAmount: boxa,
    hd: hd,
    hdAmount: hda,//remove?
    phonepak: phonepak,
    phoneid: phoneid,
    phoneAmount: phonea,
    gigpromo: gigpromo,
    wifipromo: wifipromo,
    localfee: localfee,
    sportsfee: sportsfee,
    premiums: premiums,
    premiumsAmount: premiumsa,
    dvrAmount: dvra,//remove?
    batteryAmount: batterya,
    existing: existing,
    line2: line2,
    line2Amount: line2a,//remove?
    international: international,
    total: total,

    paperBill: paper,
    notes: notes,
    referralType: ref,
    referredBy: refby,

    schedule: schedule,
    scheduleStop: scheduleStop,

    sessID: sessID
    */
  };

  // try to get the session ID from the exteranl session provider
  if(obj.sessID == '') {
    try {
      let _sessID = window.sessionStorage.getItem("sessID");
      if(_sessID) {
        obj.sessID = _sessID;
      }
    } catch(e){}
  }
 // console.log(page, session.page);
  // don't submit the partial entry on the final screen
  if((page !== null && page !== 'null') || obj.submitting) {
    if(isDev()) {
      console.log('WILL SEND STATE TO SERVER');
      console.log(obj);

      console.log(obj.sessID);
    }

    // we're using FormData instead of JSON because wordpress intercepts the JSON request and cripples it
    // if we ever switch to an actual API that isn't embedded within WP, this can be switched back to JSON
    // by passing obj to the request instead of form_data
    var form_data = new FormData();

    for ( var key in obj ) {
      form_data.append(key, obj[key]);
    }

    let lastStep = getCookie('lastStep');
    if(lastStep == '') {
      lastStep = '0';
    }
    if(pageHeaderText !== null && parseInt(page) > parseInt(lastStep)) {
      document.cookie = "lastStep=" + page.charAt() + ";"
      dataLayerPush({
        'event' : 'virtualPageview',
        'pageTitle' : pageHeaderText,
        'step' : page.charAt(),
      });
    }

    let salesRepID = getCookie('bzID');
    if(salesRepID != ''){
      form_data.append('SalesRepID', salesRepID);
    }

    if(session.page !== 'presale-notify-complete' && session.page !== 'presale-notify') {
      //return unauthenticatedApi.post(`?endpoint=submission`, form_data)
      return signupApi.put(`submit`, form_data)
        .then(response => {
            // console.log(response);

            if(response.status === 200 && response.data.hasOwnProperty('id')) {
              // console.log('HAS AN ID AND WILL SET IT')

              // manualy set the ID here because we aren't in a react component/hook
              // so there's no way to actually use little state machine
              window.sessionStorage.setItem('sessID', response.data.id);
            }

            if(response.data.hasOwnProperty('orderId')) {
              window.sessionStorage.setItem('orderID', response.data.orderId);
            }
            else if(response.data.hasOwnProperty('id')){
              window.sessionStorage.setItem('orderID', response.data.id);
              // send to scheduler
            }
        });
    }

    
  }

}

function __clear(state, payload) {
  return {};
}

function update(state, payload) {
  let newState = {
      ...state,
      session: {
        ...state.session,
        ...payload,
      },
  };

  if(payload.hasOwnProperty('page')/* && Object.keys(payload).length > 1*/) {

    if(['loading', 'loading-mocked',' intro'].indexOf(payload.page) === -1) {
      _sendState(newState);
    }
    // console.error('Use actions.setPage() instead of update({page}) to ensure that state is synced with the server.');
  }

  return newState;
}

const useStateMachineWrapper = () => {
    const sm = useStateMachine({ update, __clear });

    sm.sendState = () => {
      //
    }

    sm.actions.setPage = (page) => {
      sm.actions.update({page});

      /*
      if(page != 'loading' && page != 'loading-mocked' && page != 'intro') {
        sm.sendState();
      }
      */
    };

    return sm;
};

export default useStateMachineWrapper;

export { _sendState as sendState };
